import { render, staticRenderFns } from "./AboutProductsSmell.vue?vue&type=template&id=2e127f14&"
import script from "./AboutProductsSmell.vue?vue&type=script&lang=js&"
export * from "./AboutProductsSmell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports